import { render, staticRenderFns } from "./management-account-workspace-organization-view.vue?vue&type=template&id=1b6ae6c4"
import script from "./management-account-workspace-organization-view.vue?vue&type=script&lang=js"
export * from "./management-account-workspace-organization-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports